import React, { useContext } from 'react';
import { Context } from 'app/AppContext';

import { Wrapper, Box } from './style';

const Message: React.FC = _ => {
  const context = useContext(Context);

  return (
    <Wrapper>
      {
        context.messages.map((item: any, idx: number) => {
          return (
            <Box key={item.id} type={item.type} position={idx}>
              {item.message}
            </Box>
          )
        })
      }
    </Wrapper>
  );
};

export default Message;
